import snarkdown from 'snarkdown';

function _appendLocaleToRelativeLinks(translation, locale) {
    const linkIdentifier = /]\(\//g;
    return translation.replace(linkIdentifier, `](/${locale}/`);
}

function localizeInfoSectionData(data, t, locale) {
    if (!data) {
        return;
    }

    return {
        ...data,
        mainEntity: data.mainEntity?.map((entity) => {
            const { key, localizationData } = entity.acceptedAnswer?.text || {};
            if (!key) {
                return entity;
            }

            const translation = t(key, localizationData);
            const text = _appendLocaleToRelativeLinks(translation, locale);

            return {
                ...entity,
                acceptedAnswer: {
                    ...entity.acceptedAnswer,
                    text: snarkdown(text),
                },
            };
        }),
    };
}

function localizeProductSectionData(data, t, i18nMoney) {
    if (!data) {
        return;
    }

    const pricingOpts = {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
        useGrouping: false //No commas allowed in json-ld
    };

    return {
        ...data,
        offers: {
            ...data.offers,
            lowPrice: i18nMoney(data.offers?.lowPrice).format({
                ...pricingOpts,
                style: 'decimal',
            }),
            offers: data.offers?.offers?.map((offer) => {
                const { key, localizationData } = offer.description || {};

                if (!key) {
                    return offer;
                }

                const {
                    minPriceUsd,
                    averagePriceUsd,
                    weekendPriceUsd,
                } = localizationData;

                const description = t(key, {
                    averageMinimumPrice: i18nMoney(minPriceUsd).format(pricingOpts),
                    averagePriceUsd: i18nMoney(averagePriceUsd).format(pricingOpts),
                    weekendPrice: weekendPriceUsd
                        ? i18nMoney(weekendPriceUsd).format(pricingOpts)
                        : null,
                });

                return {
                    ...offer,
                    price: i18nMoney(offer.price).format({
                        ...pricingOpts,
                        style: 'decimal',
                    }),
                    description,
                };
            }),
        },
    };
}

function localizeStructuredData({
    structuredData,
    t,
    i18nMoney,
    locale,
}) {
    return structuredData?.map((data) => {
        if (data['@type'] === 'FAQPage') {
            return localizeInfoSectionData(data, t, locale);
        }

        if (data['@type'] === 'Product') {
            return localizeProductSectionData(data, t, i18nMoney);
        }

        return data;
    });
}

export {
    localizeStructuredData,
};
